import { Badge } from "@bcc/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@bcc/components/ui/select";
import { useTranslation } from "react-i18next";
import { setProductMappingRowTestId } from "./product-mapping-row.utils";

interface BeanzProduct {
  id: string;
  name: string;
}

interface PlatformProduct {
  id: string;
  name: string;
}

interface ProductMappingRowProps {
  beanzProduct: BeanzProduct;
  platformProducts: PlatformProduct[];
  selectedPlatformId: string | null;
  onMappingChange: (beanzId: string, platformId: string | null) => void;
  testId?: string;
}

export function ProductMappingRow({
  beanzProduct,
  platformProducts,
  selectedPlatformId,
  onMappingChange,
  testId,
}: ProductMappingRowProps) {
  const { t } = useTranslation();
  const isMapped = selectedPlatformId !== null;

  return (
    <tr
      data-testid={
        testId ?? setProductMappingRowTestId(`row-${beanzProduct.id}`)
      }
      className="border-b border-border last:border-0"
    >
      <td className="py-4 text-sm text-text-primary">{beanzProduct.name}</td>
      <td className="py-4">
        <Select
          value={selectedPlatformId || ""}
          onValueChange={(value) =>
            onMappingChange(beanzProduct.id, value || null)
          }
        >
          <SelectTrigger className="w-full max-w-xs">
            <SelectValue
              placeholder={t("onboarding.productMapping.selectProduct")}
            />
          </SelectTrigger>
          <SelectContent>
            {platformProducts.map((product) => (
              <SelectItem key={product.id} value={product.id}>
                {product.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </td>
      <td className="py-4">
        {isMapped ? (
          <Badge
            variant="default"
            className="bg-[#22C55E] hover:bg-[#22C55E]/90"
          >
            {t("onboarding.productMapping.mapped")}
          </Badge>
        ) : (
          <Badge variant="secondary" className="bg-muted text-muted-foreground">
            {t("onboarding.productMapping.unmapped")}
          </Badge>
        )}
      </td>
    </tr>
  );
}
